import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class PopupComponent {
  @Input() title: string;

  constructor (private router: Router) {}

  closePopup () {
    this.router.navigate([{ outlets: { popup: null }}]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/popups/popup/popup.component.ts